import {AxiosResponse} from 'axios'
import {corporateApi} from '../../../../setup/axios/CorporateApi'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'
import {ILocationModel} from './LocationModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const LOCATION_CREATE_URL = `${API_URL}api/v1/location/create`
export const LOCATION_GET_ALL_URL = `${API_URL}api/v1/location/getAll`
export const LOCATION_UPDATE_URL = `${API_URL}api/v1/location/update/`
export const LOCATION_DELETE_URL = `${API_URL}api/v1/location/delete/`

export function createLocation(
  location: ILocationModel
): Promise<AxiosResponse<ApiResponse<ILocationModel>>> {
  return corporateApi.post(LOCATION_CREATE_URL, location)
}

export function loadLocations(
  page = 0,
  size = 10
): Promise<AxiosResponse<ApiResponse<PageResponse<ILocationModel>>>> {
  return corporateApi.get(LOCATION_GET_ALL_URL, {params: {page, size, sort: 'province,district'}})
}

export function updateLocation(
  location: ILocationModel
): Promise<AxiosResponse<ApiResponse<ILocationModel>>> {
  return corporateApi.patch(LOCATION_UPDATE_URL + location.id, location)
}

export function deleteLocation(locationId: string) {
  return corporateApi.delete(LOCATION_DELETE_URL + locationId)
}
